<script setup lang="ts">
import CmsLink from '~/layers/cms/app/components/cms/CmsLink.vue'
import CmsText from '~/layers/cms/app/components/cms/CmsText.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Index/HeroBanner'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' },
  isVideo: { value: false, default_value: false, settingType: 'boolean', setting_label: 'czy video zamiast image' },
  showScrollButton: { value: false, default_value: false, settingType: 'boolean', setting_label: 'czy pokazać przycisk do przewiń w dół' }
}

const scrollOneViewport = () => {
  window.scrollBy({ top: window.innerHeight, behavior: 'smooth' })
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="grid grid-rows-1 grid-cols-1 h-[calc(100svh-72px)] xl:h-[calc(100svh-126px)] overflow-hidden"
    >
      <CmsVideo
        v-if="component_values?.isVideo?.value"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'video']"
        class="row-start-1 row-end-1 col-start-1 col-end-1 relative z-10 h-full w-full object-cover brightness-50 xl:brightness-100"
        fetchpriority="high"
      />
      <CmsImage
        v-else
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'image']"
        class="row-start-1 row-end-1 col-start-1 col-end-1 relative z-10 h-full w-full object-cover brightness-50 xl:brightness-100"
        :preload="{ fetchPriority: 'high' }"
      />
      <div class="row-start-1 row-end-1 col-start-1 col-end-1 flex flex-col justify-end gap-8 px-2xl py-xl xl:py-24 relative z-20 h-full pointer-events-none">
        <span class="text-H1 text-white pointer-events-auto">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
          />
        </span>

        <span class="text-H4 text-white pointer-events-auto">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
          />
        </span>

        <div class="flex flex-col items-start xl:flex-row gap-8 pointer-events-auto">
          <CmsLink
            v-slot="{ link }"
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_1']"
          >
            <AppButton
              :arrow="true"
              button-theme="Primary"
              :href="link?.href"
              :target="link?.target"
            >
              <span class="link-text">
                {{ link?.link_text ?? 'Lorem ipsum' }}
              </span>
            </AppButton>
          </CmsLink>
          <CmsLink
            v-slot="{ link }"
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_2']"
          >
            <AppButton
              :arrow="true"
              button-theme="Secondary"
              :href="link?.href"
              :target="link?.target"
            >
              <span class="link-text">
                {{ link?.link_text ?? 'Lorem ipsum' }}
              </span>
            </AppButton>
          </CmsLink>
        </div>
      </div>
      <div
        v-if="component_values?.showScrollButton?.value"
        class="row-start-1 row-end-1 col-start-1 col-end-1 hidden xl:flex flex-col justify-end gap-8 px-2xl py-xl xl:py-24 relative z-20 h-full pointer-events-none"
        @click="scrollOneViewport"
      >
        <div class="py-5 px-7.5 flex flex-row items-center gap-9 border border-white rounded-full w-fit pointer-events-auto! cursor-pointer self-end group hover:bg-Primary transition-all duration-200 rotate-90 -translate-y-full translate-x-1/2">
          <span class="text-Button text-white">Przewiń w dół</span>
          <i class="pi pi-arrow-right text-2xl! text-white group-hover:translate-x-3 duration-200" />
        </div>
      </div>
    </div>
  </CmsCustomComponent>
</template>
